<script>
    export let updateBillingRulesPhase = () => {};
</script>

<div class="flex flex-col gap-y-4 p-6 w-full">
    <div class="flex flex-col gap-y-4">
        <div class="flex justify-center">
            <img src="/imgs/illi_3@2x.png" alt="img" />
        </div>

        <div class="flex flex-col gap-y-2">
            <p class="text-[20px] font-bold">Types of Billing Rules</p>

            <p class="text-[16px]">
                There are four types of billing rule you can select from:
            </p>
        </div>

        <ol class="pl-6 list-decimal">
            <li>
                Set unit value (note: consult items are charged according to the
                AMA/ASA value assigned e.g. 2 units for 17610)
            </li>
            <li>Set gap fee</li>
            <li>
                Set hourly rate (note: uses the top of the time range for a
                quoted estimated time, or the actual time)
            </li>
            <li>Set total fee</li>
            <li>
                Set percentage of MBS schedule fee (for certain insurance types
                only)
            </li>
        </ol>
    </div>

    <!-- svelte-ignore a11y-missing-attribute -->
    <!-- svelte-ignore a11y-missing-content -->
    <div class="flex w-full justify-center">
        <div class="tabs flex gap-x-4 pb-4">
            <a
                class="tab tab-bordered cursor-pointer"
                on:click|preventDefault={updateBillingRulesPhase(1)}
            />
            <a class="tab tab-bordered tab-active cursor-default" />
            <a class="tab tab-bordered cursor-default" />
            <a class="tab tab-bordered cursor-default" />
        </div>
    </div>

    <button
        class="btn btn-md btn-secondary"
        on:click|preventDefault={() => updateBillingRulesPhase(3)}
    >
        Next
    </button>
</div>

<style>
    img {
        width: 300px;
        height: 300px;
    }
</style>
